module.exports = __webpack_public_path__ + "img/logo-card-med.03775e2d.png";